export default __webpack_public_path__ + "static/media/DocumentMobileIcon.f690f60c.svg";